import { CalendarDay, PropsGetterConfig } from '@rehookify/datepicker';
import React from 'react';
import { getDayClassName } from '../../date-time.utils';
import { TPropsGetters } from '../../date-time.types';

interface DaysProps {
  days: CalendarDay[];
  dayButton: TPropsGetters['dayButton'];
  config?: PropsGetterConfig;
}

export const Days: React.FunctionComponent<DaysProps> = ({ days, dayButton, config }) => (
  <div className="days">
    {days.map((dpDay) => (
      <button className={getDayClassName(dpDay)} key={dpDay.date} {...dayButton(dpDay, config)}>
        {dpDay.day}
      </button>
    ))}
  </div>
);
